export default function (Vue) {
  Vue.mixin({
    methods: {
      settingReal(setting) {
        const vueInst = require("@/main_app.js").default;
        return vueInst.userSettings.settings[setting] == "1";
      },
    },
  });
}
